module.exports = __webpack_public_path__ + "assets/be21275e9908a3b388205195f2a9d395.mp3";